import { getAuthHeaders, getBaseUrl } from './apiClient';

export type EditorType = 'markdown' | 'text' | 'json' | 'cta_registry' | 'model_select';

export type SupportingDataItem = {
  asset_id: string;
  name: string;
  description: string;
  editor_type: EditorType;
  group: string;
};

export type SupportingDataContent = {
  asset_id: string;
  content: string;
  editor_type: EditorType;
  last_modified: string;
  etag: string;
};

export const supportingDataService = {
  async list(): Promise<{ assets: SupportingDataItem[] }> {
    const resp = await fetch(`${getBaseUrl()}/secure/blog/supporting-data`, { headers: await getAuthHeaders() });
    if (!resp.ok) throw new Error(`Failed to list supporting data (${resp.status})`);
    return await resp.json();
  },
  async get(assetId: string): Promise<SupportingDataContent> {
    const resp = await fetch(`${getBaseUrl()}/secure/blog/supporting-data/${encodeURIComponent(assetId)}`, { headers: await getAuthHeaders() });
    if (!resp.ok) throw new Error(`Failed to get supporting data (${resp.status})`);
    return await resp.json();
  },
  async update(assetId: string, content: string, etag: string): Promise<{ etag: string }> {
    const headers = await getAuthHeaders();
    const resp = await fetch(`${getBaseUrl()}/secure/blog/supporting-data/${encodeURIComponent(assetId)}`, {
      method: 'PUT',
      headers: { ...headers, 'If-Match': etag },
      body: JSON.stringify({ content }),
    });
    if (resp.status === 409) throw new Error('This data was modified since you loaded it. Please reload and try again.');
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Failed to update supporting data: ${resp.status} ${text}`);
    }
    return await resp.json();
  },
};
